import { useEffect } from 'react'

import { Layout } from '../../components'
import { PlanGroupsPanel } from '../../components/panels'
import { DRAWER_KEYS } from '../../store/constants'

import AuthPage from './AuthPage'

/**
 * @description Renders the page for managing plan groups. 
 * It renders the AppBar, Drawer, and PlanGroupsPanel components within the AuthPage component.
 *
 * @author Maria Eduarda Franke
 * @returns {JSX.Element} The rendered PlanGroupsPage component.
 */
const PlanGroupsPage = () => {

    useEffect(() => {
        document.title = 'Grupos de Planos | LCD'
    }, [])

    return (
        <AuthPage>
            <Layout selectedKey={DRAWER_KEYS.PLAN_GROUPS} >
                <PlanGroupsPanel />
            </Layout>
        </AuthPage>
    )
}

export default PlanGroupsPage